<template>
    <div id="password-input">
        <div class="input-container">
            <div @click="focusInput(idname)" class="input-box">
                <input
                    class="input-class"
                    :id="idname"
                    maxlength="16"
                    type="password"
                    :placeholder="placeholder"
                    v-model="password"
                    @focus="showPasswordTip(true)"
                    @blur="showPasswordTip(false)"
                    @input="onInput()"
                    ref="pass"
                />
            </div>
            <div class="showPass" @click="showPassWord">
                <div class="ico ico-nopass" v-if="!showPass"></div>
                <div class="ico ico-showpass" v-else></div>
            </div>
            <div class="quickdel" @click="quickdel" v-show="showdel">
                <i class="reddel ico ico-redx"></i>
            </div>
        </div>
        <div class="error-tips-container">
            <div class="tips" v-show="isErrMsg">
                <div class="input-error">{{ message }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";

export default {
    components: {},
    props: {
        isHideRule: {
            type: Boolean,
            default: false,
        },
        idname: {
            type: String,
            default: "idname",
        },
    },
    data() {
        return {
            password: "",
            showPass: false,
            message: "",
            isErrMsg: false,
            isFocus: false,
            islang: false,
            isletter: false,
            isnumber: false,
            isOk: false,
            placeholder: this.$t("tips.Enter_your_new_password"),
            showdel: true,
        };
    },
    mounted() {
        tools.on(eventConfig.LOGIN_ERROR, (err) => {
            this.showError(err);
        });
    },
    methods: {
        showError(error) {
            this.message = error;
            this.isErrMsg = true;
        },
        focusInput(id) {
            console.log(this.idname, id);
            document.getElementById(id).focus();
        },
        onInput() {
            this.message = "";
            this.isErrMsg = false;
            this.showdel = true;
            this.checkPassword();
            this.$emit("check-event");
        },
        quickdel() {
            this.password = "";
            this.showdel = true;
            this.message = "";
            this.isErrMsg = false;
        },
        checkPassword() {
            this.islang = true;
            this.isletter = true;
            this.isnumber = true;
            let password = this.password;

            let regex1 = ".*[a-zA-z].*";
            let regex2 = ".*[0-9].*";
            if (!password.match(regex1)) this.isletter = false;
            if (!password.match(regex2)) this.isnumber = false;
            if (password.length < 6 || password.length > 16)
                this.islang = false;
            this.isOk = false;
            if (
                this.isletter &&
                this.islang &&
                this.isnumber &&
                this.password != ""
            ) {
                this.isOk = true;
            }

            //EventUtils.$emit("updateLoginUI", true);
        },
        checkError() {
            if (this.password == "") {
                this.showError(this.$t("tips.Password_is_required"));
                return;
            }
            if (!this.isletter) {
                this.showError(this.$t("tips.Password_must_contain_at"));
                return;
            }
            if (!this.islang) {
                this.showError(this.$t("tips.Password_cannot_be"));

                return;
            }
        },
        showPasswordTip(isShow) {
            this.isFocus = isShow;

            if (this.isFocus) {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(-30%)";
            } else {
                let item = document.getElementById("id-need-up");
                item.style = "transform:translateY(0%)";
            }
            if (isShow) {
                this.message = "";
                this.isErrMsg = false;

                console.log(this.idname, "focus");
            } else {
                this.checkPassword();
                this.checkError();
                console.log(this.idname, "blur");
                this.$emit("check-event");
            }
        },
        hidenError() {
            if (this.isErrMsg) {
                this.message = "";
                this.isErrMsg = false;
            }
        },
        getCountryInfo() {
            let c = this.$store.getters["common/getCountry"];
            for (let i = 0; i < dataConfig.countryList.length; i++) {
                if (c == dataConfig.countryList[i]["key"]) {
                    return dataConfig.countryList[i];
                }
            }
            return null;
        },
        showPassWord() {
            this.showPass = !this.showPass;
            if (this.showPass) {
                this.$refs.pass.setAttribute("type", "text");
            } else {
                this.$refs.pass.setAttribute("type", "password");
            }
        },
    },
    watch: {},
    destroyed() {
        tools.off(eventConfig.LOGIN_ERROR);
    },
};
</script>
<style >
@import "../../assets/css/login.css";
#password-input {
    position: relative;
    width: 580px;
    height: 82px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/input_user_password.vue